'use strict';

// Only the page language is downloaded; without its translation (or if the download fails) the calendar is in English.
const LOCALES = {
    cs: () => import(/* webpackChunkName: "datepicker-cs" */ 'vanillajs-datepicker/locales/cs'),
    de: () => import(/* webpackChunkName: "datepicker-de" */ 'vanillajs-datepicker/locales/de'),
    es: () => import(/* webpackChunkName: "datepicker-es" */ 'vanillajs-datepicker/locales/es'),
    hu: () => import(/* webpackChunkName: "datepicker-hu" */ 'vanillajs-datepicker/locales/hu'),
    no: () => import(/* webpackChunkName: "datepicker-no" */ 'vanillajs-datepicker/locales/no'),
    pl: () => import(/* webpackChunkName: "datepicker-pl" */ 'vanillajs-datepicker/locales/pl'),
    ro: () => import(/* webpackChunkName: "datepicker-ro" */ 'vanillajs-datepicker/locales/ro'),
    ru: () => import(/* webpackChunkName: "datepicker-ru" */ 'vanillajs-datepicker/locales/ru'),
    sk: () => import(/* webpackChunkName: "datepicker-sk" */ 'vanillajs-datepicker/locales/sk'),
    uk: () => import(/* webpackChunkName: "datepicker-uk" */ 'vanillajs-datepicker/locales/uk'),
};

// Resolves to the translation module, or null. A second call during the download waits for the same file.
export function loadLocale() {
    const load = LOCALES[window.LOCALE];
    return load ? load().catch(() => null) : Promise.resolve(null);
}
